import { PUBLIC_SITE } from '../settings';
import type { RichEndingResult } from 'src/interviews/components/Completion/components/RichEndings/useRichEndingContext';

export async function send({
  email,
  result,
  subject,
  template,
}: {
  email: string;
  result: RichEndingResult;
  subject?: string;
  template: 'sx' | 'dxoc' | 'treatment-plan';
}): Promise<unknown> {
  const url = `${PUBLIC_SITE}/mailchimp/messages/send`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      to: [email],
      result: {
        differential: result.differential,
        interview_result: result.interviewResult,
        related_readings: result.relatedReadings,
        treatment_plan: result.treatmentPlan,

        /** The first item is assumed to be an OMD card,
         * see src/interviews/components/Completion/hooks/useTreatmentSuppliers.
         *
         * Links cannot be JSON.stringify. So, we'll re-create the OMD card when creating the email
         */
        treatment_suppliers: result.treatmentSuppliers?.slice(1),
      },
      subject,
      template,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const responseBody = await res.json();

    const error = {
      data: {
        status: res.status,
        body: responseBody,
      },
    };

    throw error;
  }

  return await res.json();
}

export async function subscribeToMailingList({
  email,
  newsletters,
}: {
  email: string;
  newsletters?: string;
}): Promise<unknown> {
  const url = `${PUBLIC_SITE}/convertkit`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      email: email,
      newsletters_subscribed: newsletters,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const responseBody = await res.json();

    const error = {
      data: {
        status: res.status,
        body: responseBody,
      },
    };

    throw error;
  }

  return await res.json();
}

export async function subscribeToSequence({
  email,
  sequenceId,
}: {
  email: string;
  sequenceId: string;
}): Promise<unknown> {
  const url = `${PUBLIC_SITE}/convertkit/sequences/${sequenceId}/add`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      email: email,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    const responseBody = await res.json();

    const error = {
      data: {
        status: res.status,
        body: responseBody,
      },
    };

    throw error;
  }

  return await res.json();
}
